import { minuteOfDay } from "./timeOffForm";

const MINUTES_PER_DAY = 24 * 60;

/** The grid slot a point in a calendar column falls in, rounded down to its start. */
export function slotAtYOffset({
  yOffset,
  slotHeight,
  startTime,
  timeStep,
}: {
  yOffset: number;
  slotHeight: number;
  startTime: string;
  timeStep: number;
}): { index: number; time: string } {
  const index = Math.max(Math.trunc(yOffset / slotHeight), 0);
  const minutes = (minuteOfDay(startTime) + index * timeStep) % MINUTES_PER_DAY;

  const hour = String(Math.floor(minutes / 60)).padStart(2, "0");
  const minute = String(minutes % 60).padStart(2, "0");
  return { index, time: `${hour}:${minute}` };
}
